import { finalize } from 'rxjs/operators';
import { AfterContentInit, Component, Input, OnInit } from '@angular/core';
import { Color } from 'chart.js';
import { PlycaDataService } from '../../../services/plyca.service';
import { UIService } from '../../ui.service';
import { ActivatedRoute, Router } from '@angular/router';
import { WaitLoadingService } from '../../components/common/waitLoading/wait-loading.service';
import {
  ProcedureMapComponent,
  DivisionPhaseDTO,
} from '../procedures/procedureMap.component';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from '../../user.service';
import { ProfileService } from '../../../services/profile.services';
import { Configuration } from '../../conf/app.constants';
import { BaseComponent } from '../../components/common/baseComponent/base.component';
import { DialogService, DynamicDialogConfig } from 'primeng-lts/dynamicdialog';
import { OnDestroy } from '@angular/core';
import { AppConfiguration } from '../../conf/app.configuration';
import { getSimpleIdentifierFromString } from '../../api/plyca-dtos';

@Component({
  selector: 'dossierProgressGraph',
  templateUrl: 'dossierProgressGraph.template.html',
})
export class DossierProgressGraphComponent
  extends BaseComponent
  implements AfterContentInit, OnDestroy {
  @Input()
  public dossier: any;

  loaded = false;
  graphicLoaded = false;

  chartTopType = 'doughnut';
  chartTopLabels: string[];
  chartTopData: any[];
  chartColors: Array<Color> = [];
  totalProgress: string;
  chartOptions: any;
  loadedProgressData: Array<any>;
  chartShowPhases = true;
  phaseStr: string;
  phaseId: string;
  filteredData: any[];

  constructor(
    public uiService: UIService,
    public plycaService: PlycaDataService,
    protected route: ActivatedRoute,
    protected waitService: WaitLoadingService,
    public dialogService: DialogService,
    public translate: TranslateService,
    public configuration: Configuration,
    public profileService: ProfileService,
    protected router: Router,
    public userService: UserService,
    private appConfig: AppConfiguration
  ) {
    super();
  }

  ngAfterContentInit(): void {
    console.log('cargando grafico');
    this.chartOptions = Object.assign({}, this.uiService.pChartOptions);
    if (!this.chartOptions.tooltips) {
      this.chartOptions.tooltips = { enabled: false };
    } else {
      this.chartOptions.tooltips.enabled = false;
    }

    this.dossier['PROC_LETTERS'] = '';
    if (
      this.dossier &&
      this.dossier.division &&
      this.dossier.division.procedure
    ) {
      this.dossier['PROC_LETTERS'] = this.calculateLetters(
        this.dossier.division.procedure.description
      );
    }
    this.loadGraphicData();
    this.loaded = true;
    console.log('Grafico cargado');
  }

  processChartData(phaseId?: string): void {
    if (phaseId) {
      this.phaseStr = phaseId;
    }
    let labels: string[] = [];
    let dataList: any[] = [];
    let data0: any = { data: [] };
    let data1: any = { data: [] };
    let data: any[] = [data0, data1];
    let colors: Array<Color> = [];
    colors[0] = Object.assign({}, this.uiService.chartColorsDef);
    colors[1] = Object.assign({}, this.uiService.chartColorsDef);
    // let backgroundColor: string[] = Object.assign(
    //   [],
    //   this.uiService.chartColorsDef.backgroundColor
    // );
    // let borderColor: string[] = Object.assign(
    //   [],
    //   this.uiService.chartColorsDef.borderColor
    // );
    // let hoverBackgroundColor: string[] = Object.assign(
    //   [],
    //   this.uiService.chartColorsDef.hoverBackgroundColor
    // );
    // (<string[]>colors[0].backgroundColor) = backgroundColor;
    // (<string[]>colors[0].borderColor) = borderColor;
    // (<string[]>colors[0].hoverBackgroundColor) = hoverBackgroundColor;

    let sum: number[] = [0, 0];
    for (let dato of this.loadedProgressData) {
      if (phaseId) {
        this.chartShowPhases = false;
        if (dato.columns.DESC_FASE.value === phaseId) {
          this.phaseId = dato.columns.FASE_REGLA.value;
          labels.push(dato.columns.DESC_BLOQUE.value);
          dataList.push(dato.columns);
          let value: number = Number(dato.columns.COUNT_REGLAS_EJEC.value);
          data0.data.push(value);
          sum[0] += value;
          value = Number(dato.columns.COUNT_REGLAS_OBLIG.value);
          data1.data.push(value);
          sum[1] += value;
        }
      } else {
        this.chartShowPhases = true;
        if (
          labels.length === 0 ||
          labels[labels.length - 1] !== dato.columns.DESC_FASE.value
        ) {
          labels.push(dato.columns.DESC_FASE.value);
          dataList.push(dato.columns);
          let value: number = Number(dato.columns.COUNT_REGLAS_EJEC.value);
          data0.data.push(value);
          sum[0] += value;
          value = Number(dato.columns.COUNT_REGLAS_OBLIG.value);
          data1.data.push(value);
          sum[1] += value;
        } else {
          let value: number =
            Number(data0.data[labels.length - 1]) +
            Number(dato.columns.COUNT_REGLAS_EJEC.value);
          data0.data[labels.length - 1] = value;
          sum[0] += Number(dato.columns.COUNT_REGLAS_EJEC.value);
          value =
            Number(data1.data[labels.length - 1]) +
            Number(dato.columns.COUNT_REGLAS_OBLIG.value);
          data1.data[labels.length - 1] = value;
          sum[1] += Number(dato.columns.COUNT_REGLAS_OBLIG.value);
        }
      }
    }
    // if (sum[0] < sum[1]) {
    //   //labels.push('');
    //   data0.data.push(sum[1] - sum[0]);
    //   (<string[]>colors[0].backgroundColor)[data0.data.length - 1] =
    //     'rgba(0,0,0,0)';
    //   (<string[]>colors[0].borderColor)[data0.data.length - 1] =
    //     'rgba(0,0,0,0)';
    //   (<string[]>colors[0].hoverBackgroundColor)[data0.data.length - 1] =
    //     'rgba(0,0,0,0)';
    // }
    this.totalProgress = Math.round((sum[0] / sum[1]) * 100) + '%';
    this.chartTopLabels = labels;
    this.chartTopData = [];
    this.chartTopData['datasets'] = [];
    //this.chartTopData['labels'] = labels;

    let dataElement = {
      // El color de los puntos
      borderColor: this.uiService.borderColor,
      // El color de las líneas
      backgroundColor: this.uiService.backgroundColor,
      fill: true,
      circumference: (sum[0] / sum[1]) * 360,
      borderWith: 2,
      legend: {
        display: false,
      },
      // options: this.uiService.pChartOptions,
    };
    //dataElement['label'] = 'uno';
    dataElement['data'] = data0['data'];

    this.chartTopData['datasets'].push(dataElement);

    let dataElement2 = {
      // El color de los puntos
      borderColor: this.uiService.borderColor,
      // El color de las líneas
      backgroundColor: this.uiService.backgroundColor,
      fill: true,
      borderWith: 2,
      legend: {
        display: false,
      },
      // options: this.uiService.pChartOptions,
    };
    // dataElement['label'] = 'undoso';
    dataElement2['data'] = data1['data'];
    this.chartTopData['datasets'].push(dataElement2);

    this.chartOptions = this.uiService.barChartOptions;
    this.filteredData = dataList;
    this.graphicLoaded = sum[0] + sum[1] > 0;
    setTimeout(() => {
      this.chartColors = colors;
    }, 5);
  }

  isGraphicLoaded() {
    return this.graphicLoaded;
  }

  chartClicked(e: any): void {
    let val = -1;
    if (e) {
      val = e.element.index;
    }

    if (this.chartShowPhases) {
      let phase: string = this.chartTopLabels[val];
      this.processChartData(phase);
    }
  }

  isProcedureMapAvailable() {
    // Si es tramitacion flexible (modo=9) mostrar el mapa siempre
    if (
      getSimpleIdentifierFromString(
        this.dossier.classification?.processingMode?.identifier
      ) === '9'
    ) {
      return true;
    }
    let available = false;
    let _profiles = this.appConfig.getValue('procedureMap.profiles');
    if (_profiles) {
      available = this.userService.hasRoles(_profiles);
    }
    return available;
  }

  isFormalized() {
    return +getSimpleIdentifierFromString(this.dossier.phase.identifier) >= 40;
  }

  viewBlockDef(phase: string, division: string, block: string): void {
    if (!this.isProcedureMapAvailable())
      return;
    let config: DynamicDialogConfig = {
      header: this.translate.instant('Tasks.procedureMap.title'),
      width: '95%',
      style: { overflow: 'scroll' },
      styleClass: 'formEdition',
    };
    let divisionPhases: DivisionPhaseDTO[] = [];

    let lastDivision: DivisionPhaseDTO;
    for (let dato of this.loadedProgressData) {
      let divPhase = new DivisionPhaseDTO();
      divPhase.phase = dato.columns.FASE_REGLA.value;
      divPhase.division = dato.columns.DIVISION.value;
      divPhase.description = dato.columns.DESC_FASE.value;
      if (
        !lastDivision ||
        lastDivision.phase !== divPhase.phase ||
        lastDivision.division !== divPhase.division
      ) {
        lastDivision = divPhase;
        divisionPhases.push(divPhase);
      }
    }

    config['dossierId'] = this.dossier.identifier;
    config['division'] = division;
    config['phase'] = phase;
    config['block'] = block;
    config['allProfiles'] = this.profileService.getProfiles();
    config['divisionPhases'] = divisionPhases;

    const ref = this.dialogService.open(ProcedureMapComponent, config);
  }

  loadGraphicData(): void {
    this.subscribe(
      this.plycaService
        .getAttributeValue(
          'PROGRESO_EXP_STD',
          'PROPUESTAID=' + this.dossier.identifier
        )
        .pipe(
          finalize(() => {
            this.waitService.cancelWaiting();
          })
        ),
      (x) => {
        if (x.values) {
          this.loadedProgressData = x.values;
          this.processChartData();
        }
      },
      (err) => {
        console.log('Error cargando datos atributo: PROGRESO_EXP_STD');
        console.log(err);
      }
    );
  }

  calculateLetters(originalText: string): string {
    let txt = '';
    if (originalText) {
      let words: string[] = originalText.split(' ');
      for (let entry of words) {
        txt = txt + entry.slice(0, 1).toUpperCase();
      }
    }
    return txt;
  }

  isLoaded(): boolean {
    return this.loaded;
  }

  isChartShowPhases(): boolean {
    return this.chartShowPhases;
  }
}
